import { Component, Injector, ViewChild, OnInit, Input, TemplateRef, AfterViewInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl, ValidatorFn, FormArray } from '@angular/forms';
import moment from "moment";
import { PerguntaEnergiaDTO, TipoPerguntaEnum, QuestionarioRespostaEnergiaDTO, OpcaoQuestionarioRespostaEnergiaDTO, TipoValorPerguntaEnum, TamanhoPerguntaEnum, TipoCustomizacaoEnum, ResponsavelAvaliacaoEconomiaDTO } from '../../model/questionario.model';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-questionario-complementar',
    templateUrl: './questionario-complementar.component.html',
    styleUrls: ['./questionario-complementar.component.scss'],
    standalone: false
})
export class QuestionarioComplementarComponent implements OnInit, AfterViewInit {
    
    @Input()
    public listaPerguntas: PerguntaEnergiaDTO[];

    @Input()
    public isEsco: boolean;

    private _listaResposta: QuestionarioRespostaEnergiaDTO[];
    @Input() set listaResposta(value: QuestionarioRespostaEnergiaDTO[]){
        this._listaResposta = value;
        if (this._listaResposta) {
            this.preencherTela();
        }
    }

    @ViewChild('RESPONSAVEL_PELA_AVALIACAO') 
    private RESPONSAVEL_PELA_AVALIACAO: TemplateRef<any>;

    private _valorProjeto: number;
    @Input() set valorProjeto(valor: number) {
        this._valorProjeto = valor;
        if (this._valorProjeto && this.formGroup) {
            this.setValorProjeto();
        }
    }

    public questionarioForm: UntypedFormGroup;
    public formGroup: UntypedFormGroup;
    
    public respostas: UntypedFormArray = new UntypedFormArray([]);

    private static readonly TIPO_INPUT_RADIO :string = 'radio';
    private static readonly TIPO_INPUT_CHECKBOX :string = 'checkbox';
    private static readonly TIPO_INPUT_TEXT :string = 'text';
    private static readonly TIPO_INPUT_CUSTOM :string = 'custom';
    private static readonly TIPO_INPUT_DATE :string = 'date';

    private static readonly CAMPO_CUSTOMIZADO_IDENTIFICACAO_RESPONSAVEL_AVALIACAO = 'identificacao_responsavel_avaliacao';

    exibeQuestoes: boolean = false;
    exibePerguntasTecnicas: boolean = true;
    idPerguntaTecnicaDB = 44;
    idRespostaProjetoEhMaisComplexo = 101;

    // Variavel com os id's das perguntas de acordo com a base de dados. *Não alterar.
    // As perguntas serão validadas por blocos.
    configuracaoBlocos = {
        "bloco 1.a, 1.b...": [22, 23, 40],
        "bloco 2.a, 2.b...": [24, 25, 41],
        "bloco 3.a, 3.b...": [26, 27, 28, 42],
    };

    constructor(
        protected injector: Injector,
        private formBuilder: UntypedFormBuilder,
        private sanitizer: DomSanitizer) {

    }
    
    ngAfterViewInit(): void {
        /* Atualizar o template antes de acabar a geração do formulário gera Mudança em atributo chegado. Necessário aguardar um pouco para que o formulário 
           termine a renderização e checagem, já que o binding dos componentes acontece em tempo diferente da inicialização do formulário */
        setTimeout(() => {
            this.listaPerguntas.forEach(pergunta => {
                if (pergunta.tipoPergunta == TipoPerguntaEnum.PERSONALIZADA) {
                    pergunta.frontCustomTemplate = this[pergunta.tipoCustomizacao];
                }
            });
            this.setValorProjeto();
        }, 500);
    }
    
    ngOnInit() {

        let respostasFormArray: UntypedFormArray = this.formBuilder.array([]);
        let idUltimoGrupo: number = -1; 
        
        this.listaPerguntas.forEach(pergunta => {

            pergunta.frontTitulo = this.sanitizer.bypassSecurityTrustHtml(pergunta.tituloPergunta);
            pergunta.frontSubtitulo = this.sanitizer.bypassSecurityTrustHtml(pergunta.textoPergunta);
            if (pergunta.grupo) {
                pergunta.grupo.frontTitulo = this.sanitizer.bypassSecurityTrustHtml(pergunta.grupo.titulo);
                pergunta.grupo.frontSubtitulo = this.sanitizer.bypassSecurityTrustHtml(pergunta.grupo.subtitulo);
            }

            if (this.verificaPerguntaTemTextoComplementar(pergunta)) {
                pergunta.frontTemTextoComplementar = true;
            }

            idUltimoGrupo = this.trataGrupoPergunta(pergunta, idUltimoGrupo);

            let tipoInput = this.getTipoInput(pergunta);
            if (tipoInput == QuestionarioComplementarComponent.TIPO_INPUT_RADIO) {
                let respostaFormGroup: AbstractControl = this.formBuilder.group({
                    idPergunta: pergunta.id,
                    resposta: new UntypedFormControl('', Validators.required)
                });
                respostasFormArray.push(respostaFormGroup);
            } else if (tipoInput == QuestionarioComplementarComponent.TIPO_INPUT_CHECKBOX) {
                let perguntaCheckBoxArray:UntypedFormArray = new UntypedFormArray([], minSelectedCheckboxes(1));    
                for (let indOpResposta=0; indOpResposta < pergunta.listaOpcoes.length; indOpResposta++) {
                    perguntaCheckBoxArray.push(new UntypedFormControl(false));
                }

                let respostaFormGroup: AbstractControl = this.formBuilder.group({
                    idPergunta: pergunta.id,
                    resposta: perguntaCheckBoxArray,
                    textoComplementar: new UntypedFormControl('') 
                });
                respostasFormArray.push(respostaFormGroup);        
            } else if (tipoInput == QuestionarioComplementarComponent.TIPO_INPUT_TEXT) {
                let respostaFormGroup: AbstractControl = this.formBuilder.group({
                    idPergunta: pergunta.id,
                    resposta: new UntypedFormControl('', Validators.required) 
                });
                respostasFormArray.push(respostaFormGroup);
            } else if (tipoInput == QuestionarioComplementarComponent.TIPO_INPUT_DATE) {
                let respostaFormGroup: AbstractControl = this.formBuilder.group({
                    idPergunta: pergunta.id,
                    resposta: new UntypedFormControl(undefined, Validators.required) 
                });
                respostasFormArray.push(respostaFormGroup);
            } else if (tipoInput == QuestionarioComplementarComponent.TIPO_INPUT_CUSTOM) {
                let respostaFormGroup: AbstractControl = this.criaPerguntaCustomizada(pergunta);
                respostasFormArray.push(respostaFormGroup);
            }

        });                        
        
        this.formGroup = this.formBuilder.group({
            respostas: respostasFormArray
        });
                
        this.preencherTela();
    }

    public get respostasQuestionario(): UntypedFormArray { 
        return this.formGroup.get('respostas') as UntypedFormArray; 
    }
   
    private trataGrupoPergunta(pergunta: PerguntaEnergiaDTO, idUltimoGrupo: number): number {
        if (!pergunta.grupo) {
            return -1;
        }
        
        if (!idUltimoGrupo || idUltimoGrupo == -1 || idUltimoGrupo != pergunta.grupo.id) {
            idUltimoGrupo = pergunta.grupo.id;
            pergunta.frontIsPerguntaNovoGrupo = true;
        } 

        return idUltimoGrupo;
    }

    private criaPerguntaCustomizada(pergunta: PerguntaEnergiaDTO): AbstractControl {
        let customFormGroup: AbstractControl = undefined;

        if (pergunta.tipoCustomizacao == TipoCustomizacaoEnum.RESPONSAVEL_PELA_AVALIACAO) {  
            customFormGroup = this.formBuilder.group({
                                idPergunta: pergunta.id,
                                nomeInterno: pergunta.tipoCustomizacao,
                                cnpj: new UntypedFormControl('') ,
                                cpf: new UntypedFormControl('') ,
                                nome: new UntypedFormControl(''),
                                profissao: new UntypedFormControl(''),
                                registro: new UntypedFormControl(''),
                                orgaoRegistro: new UntypedFormControl(''),
                                unidadeFederacaoOrgao: new UntypedFormControl('')
            });
        }

        return customFormGroup;
    }

    public retornaRespostasPreenchidas(): QuestionarioRespostaEnergiaDTO[] {
        let listaResposta: QuestionarioRespostaEnergiaDTO[] = [];
        let outer = this;
        
        if (this.exibeQuestoes) {
            this.respostasQuestionario.controls.forEach(ctrlGroupResposta => {
                let itemResposta = new QuestionarioRespostaEnergiaDTO();
                let formGroupResposta: UntypedFormGroup = ctrlGroupResposta as UntypedFormGroup;
                itemResposta.idPergunta = formGroupResposta.controls.idPergunta.value;
                let pergunta = outer.getPerguntaPorId(itemResposta.idPergunta);
                
                if (formGroupResposta.controls.nomeInterno) { // campo customizado
                    this.trataRespostaCampoCustomizado(formGroupResposta.controls.nomeInterno.value, formGroupResposta, itemResposta);
                } else {
                    let auxResposta: any = formGroupResposta.controls.resposta.value;
                    if (Array.isArray(auxResposta)) {
                        itemResposta.conteudo = this.trataRespostaArray(itemResposta.idPergunta, auxResposta);
                        itemResposta.conteudoComplementar = formGroupResposta.controls.textoComplementar.value;
                    } else if (pergunta.tipoPergunta == TipoPerguntaEnum.TEXTO_LIVRE && pergunta.tipoValor == TipoValorPerguntaEnum.DATA) {
                        outer.trataRespostaDate(auxResposta, itemResposta);
                    } else {
                        itemResposta.conteudo = auxResposta;
                    }
                }
    
                listaResposta.push(itemResposta);
    
            });    
    
        } else {
            listaResposta.push(this.itemRespostaTecnicia());
        }

        return listaResposta;
    }

    private trataRespostaCampoCustomizado(nomeInterno: string, formGroup: UntypedFormGroup, itemResposta: QuestionarioRespostaEnergiaDTO): void {
        if (nomeInterno == TipoCustomizacaoEnum.RESPONSAVEL_PELA_AVALIACAO) {
            const cnpjResponsavelAvaliacao = formGroup.controls.cnpj.value;
            itemResposta.conteudo = `cnpj=${cnpjResponsavelAvaliacao ? cnpjResponsavelAvaliacao : ''};cpf=${formGroup.controls.cpf.value};nome=${formGroup.controls.nome.value};profissao=${formGroup.controls.profissao.value};numeroRegistroProfissional=${formGroup.controls.registro.value};orgaoRegistro=${formGroup.controls.orgaoRegistro.value};unidadeFederacaoOrgao=${formGroup.controls.unidadeFederacaoOrgao.value}`;            
        } else {
            throw new Error('Campo customizado desconhecido');
        }
    }

    private trataRespostaArray(idPergunta: number, auxResposta: boolean[]): string {
        let perguntaEnergiaDTO = this.getPerguntaPorId(idPergunta);
        let idsConcatenados: string = '';
        for (let ind = 0; ind < perguntaEnergiaDTO.listaOpcoes.length; ind++) {
            const boolResp:boolean = auxResposta[ind];
            if (boolResp) {
                if (idsConcatenados.length > 0) {
                    idsConcatenados += ';';
                }
                idsConcatenados += perguntaEnergiaDTO.listaOpcoes[ind].id;
            }
        };
        
        return idsConcatenados;
    }

    private trataRespostaDate(valor: any, itemResposta: QuestionarioRespostaEnergiaDTO): void {
        if (!valor) {
            return;
        }
        itemResposta.conteudo = moment(valor).format('YYYY-MM-DD');
        
    }


    public getTipoInput(pergunta: PerguntaEnergiaDTO ): string {
        if (pergunta.tipoPergunta == TipoPerguntaEnum.ESCOLHA_UNICA) {
			return QuestionarioComplementarComponent.TIPO_INPUT_RADIO;
		} else if (pergunta.tipoPergunta == TipoPerguntaEnum.ESCOLHA_MULTIPLA || pergunta.tipoPergunta == TipoPerguntaEnum.LISTA_COM_REDFLAG) {
			return QuestionarioComplementarComponent.TIPO_INPUT_CHECKBOX;
		} else if (pergunta.tipoPergunta == TipoPerguntaEnum.TEXTO_LIVRE) {
            if (pergunta.tipoValor == TipoValorPerguntaEnum.DATA) {
                return QuestionarioComplementarComponent.TIPO_INPUT_DATE;
            } else {
                return QuestionarioComplementarComponent.TIPO_INPUT_TEXT;
            }
		} else if (pergunta.tipoPergunta == TipoPerguntaEnum.PERSONALIZADA) {
            return QuestionarioComplementarComponent.TIPO_INPUT_CUSTOM;
        }
    }

    private getPerguntaPorId(idPergunta: number) {
        let perguntaEncontrada = null;
        this.listaPerguntas.forEach(pergunta => {
            if (pergunta.id == idPergunta) {
                perguntaEncontrada = pergunta;
            }
        });

        return perguntaEncontrada;
    }

    public checkboxChange(event: any, opcaoResposta: OpcaoQuestionarioRespostaEnergiaDTO, idPergunta: number){
        let perguntaAtual:PerguntaEnergiaDTO = this.getPerguntaPorId(idPergunta);
        perguntaAtual.frontMostrarTextoComplementar = event.target.checked;
        if (opcaoResposta.exigeTextoComplementar) {
            perguntaAtual.frontMostrarTextoComplementar = event.target.checked;
        }        
    } 

    private verificaPerguntaTemTextoComplementar(pergunta: PerguntaEnergiaDTO): boolean {
        let retorno = false;
        if (pergunta.listaOpcoes) {
            pergunta.listaOpcoes.forEach(opcao => {
                if (opcao.exigeTextoComplementar) {
                    retorno = true;
                }
            });
        }

        return retorno;
    }

    public getMascaraPergunta(tipo: TipoValorPerguntaEnum) {
        if (tipo == TipoValorPerguntaEnum.NUMERO_INTEIRO) {
            return 'INTEIRO';
        } else if (tipo == TipoValorPerguntaEnum.NUMERO_DECIMAL) {
            return 'DECIMAL';
        } else if (tipo == TipoValorPerguntaEnum.CNPJ) {
            return 'CNPJ';
        } else if (tipo == TipoValorPerguntaEnum.CEP) {
            return 'CEP';
        } else {
            return null;
        }
    }

    public getClassTamanhoPergunta(pergunta: PerguntaEnergiaDTO) {
        if (pergunta.tamanho == TamanhoPerguntaEnum.MUITO_PEQUENO) {
            return 'col-md-1';
        } else if (pergunta.tamanho == TamanhoPerguntaEnum.PEQUENO) {
            return 'col-md-3';
        } else if (pergunta.tamanho == TamanhoPerguntaEnum.MEDIO) {
            return 'col-md-6';
        } else if (pergunta.tamanho == TamanhoPerguntaEnum.GRANDE) {
            return 'col-md-12';
        }

        return'col-md-6';
     }

     public preencherTela(): void {
        if (this.formGroup && this._listaResposta) {
            this.respostasQuestionario.controls.forEach(ctrlGroupResposta => {
                let formGroupResposta: UntypedFormGroup = ctrlGroupResposta as UntypedFormGroup;
                let idPergunta: number = formGroupResposta.controls.idPergunta.value;
                let pergunta: PerguntaEnergiaDTO = this.getPerguntaPorId(idPergunta);
                let respCarregada: QuestionarioRespostaEnergiaDTO = this.getValueFromResposta(idPergunta);

                if (pergunta.tipoPergunta == TipoPerguntaEnum.ESCOLHA_UNICA) {
                    formGroupResposta.patchValue({
                        resposta: this.trataConteudoRespostaEscolhaUnica(respCarregada)
                    });
                } else if (pergunta.tipoPergunta == TipoPerguntaEnum.TEXTO_LIVRE) {
                    let conteudo = this.trataConteudoTextoLivreCarregado(pergunta, respCarregada);
                    formGroupResposta.patchValue({
                        resposta: conteudo
                    });
                } else if (pergunta.tipoPergunta == TipoPerguntaEnum.ESCOLHA_MULTIPLA || 
                           pergunta.tipoPergunta == TipoPerguntaEnum.LISTA_COM_REDFLAG) {
                    let boolVet: boolean[] = [];
                    let respSplit = respCarregada.conteudo.split(';');
                    for (let indOpcao = 0; indOpcao < pergunta.listaOpcoes.length; indOpcao++) {
                        let achou = false;
                        for (let ind = 0; ind < respSplit.length; ind++) {
                            if (pergunta.listaOpcoes[indOpcao].id == Number(respSplit[ind])) {
                                achou = true;
                                if (pergunta.listaOpcoes[indOpcao].exigeTextoComplementar) {
                                    pergunta.frontMostrarTextoComplementar = true;
                                }
                                break;
                            }
                        }
                        boolVet.push(achou);                        
                    }
                    formGroupResposta.patchValue({
                        resposta: boolVet,
                        textoComplementar: respCarregada.conteudoComplementar
                    });

                } else if (pergunta.tipoPergunta == TipoPerguntaEnum.PERSONALIZADA) {
                    if (pergunta.tipoCustomizacao == TipoCustomizacaoEnum.RESPONSAVEL_PELA_AVALIACAO) {
                        let obj: ResponsavelAvaliacaoEconomiaDTO = this.carregaResponsavelAvaliacao(pergunta, respCarregada.conteudo);
                        formGroupResposta.patchValue({
                            cnpj: obj.cnpj,
                            cpf: obj.cpf,
                            nome: obj.nome,
                            profissao: obj.profissao,
                            registro: obj.numeroRegistroProfissional,
                            orgaoRegistro: obj.orgaoRegistro,
                            unidadeFederacaoOrgao: obj.unidadeFederacaoOrgao,
                        });
                    }
                }
            
            });
        }
    }

    private setValorProjeto() {
        let valor = this._valorProjeto;        
        const perguntaTecnica = this.getFormPerguntaTecnica();
        if (valor && valor >= 400000) {
            this.exibePerguntasTecnicas = false;
            this.exibeQuestoes = true;
            perguntaTecnica.patchValue({resposta: 101});
        } else if (valor && valor < 400000) {            
            this.exibePerguntasTecnicas = true;
            this.exibeQuestoes = false;
            perguntaTecnica.patchValue({resposta: ''});
        }
    }

    private getValueFromResposta(idPergunta: number): QuestionarioRespostaEnergiaDTO {
        for (let ind = 0; ind < this._listaResposta.length; ind++) {
            if (this._listaResposta[ind].idPergunta == idPergunta) {
                return this._listaResposta[ind];
            }
        }
    }

    private carregaResponsavelAvaliacao(pergunta:PerguntaEnergiaDTO, conteudo: string): ResponsavelAvaliacaoEconomiaDTO {
        let conteudoSplit: string[] = conteudo.split(";")
        let obj: ResponsavelAvaliacaoEconomiaDTO = new ResponsavelAvaliacaoEconomiaDTO();
        for (let indCampo = 0; indCampo < conteudoSplit.length; indCampo++) {
            if (conteudoSplit[indCampo].startsWith('cnpj=')) {
                obj.cnpj = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);                
            } else if (conteudoSplit[indCampo].startsWith('cpf=')) {
                obj.cpf = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);                
            } else if (conteudoSplit[indCampo].startsWith('nome=')) {
                obj.nome = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);                
            } else if (conteudoSplit[indCampo].startsWith('profissao=')) {
                obj.profissao = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);                
            } else if (conteudoSplit[indCampo].startsWith('numeroRegistroProfissional=')) {
                obj.numeroRegistroProfissional = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);                
            } else if (conteudoSplit[indCampo].startsWith('orgaoRegistro=')) {
                obj.orgaoRegistro = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);                
            } else if (conteudoSplit[indCampo].startsWith('unidadeFederacaoOrgao=')) {
                obj.unidadeFederacaoOrgao = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);                
            }else {
                throw new Error("Campo inválido para a pergunta " + pergunta.id) + ". Conteudo: " + conteudo;
            }
        }

        return obj;
    }

    private trataConteudoTextoLivreCarregado (pergunta: PerguntaEnergiaDTO, resposta: QuestionarioRespostaEnergiaDTO): string | Date {
        if (pergunta.tipoValor == TipoValorPerguntaEnum.DATA) {
            let date: Date = moment(resposta.conteudo, 'YYYY-MM-DD').toDate();
            return date;
        }
        return resposta?.conteudo
    }

    private trataConteudoRespostaEscolhaUnica(resposta: QuestionarioRespostaEnergiaDTO): number {
        if (resposta?.conteudo) {
            return Number(resposta.conteudo);        
        } else {
          return undefined;  
        }
    }

    /**
    * Esconder a pergunta caso ela seja somente para esco e o cliente atual não é uma esco
    * ou caso a pergunta seja para cliente não esco e o cliente atual é uma esco
    */
   public esconderPerguntaPorTipoTomador(pergunta: PerguntaEnergiaDTO): boolean {
        if (!pergunta.disponivelSomenteConsumidorFinal && !pergunta.disponivelSomenteEsco) {
           return false;
       }
       
       if (pergunta.disponivelSomenteConsumidorFinal && this.isEsco) {
           return true;
       }

       if (pergunta.disponivelSomenteEsco && !this.isEsco) {
           return true;
       }

   }

    trocarSelecao() {
        this.exibeQuestoes = this.getFormPerguntaTecnica().value?.resposta === this.idRespostaProjetoEhMaisComplexo;
    }

    exibePerguntaTecnica(pergunta: PerguntaEnergiaDTO): boolean {        
        return Number(pergunta.id) === this.idPerguntaTecnicaDB && this.exibePerguntasTecnicas;
    }

    ehPerguntaTecnica(pergunta: PerguntaEnergiaDTO): boolean {
        return Number(pergunta.id) === this.idPerguntaTecnicaDB;
    }

    getFormPerguntaTecnica(): AbstractControl<any, any> {
        const formArray = this.formGroup.get('respostas') as FormArray;
        return formArray.controls.find(item => Number(item?.value?.idPergunta) === this.idPerguntaTecnicaDB);
    }

    verificarIntegridadeDosBlocos(): boolean {
        const formArray = this.formGroup.get('respostas') as FormArray;

        const existePeloMenosUmCompleto = Object.keys(this.configuracaoBlocos).some(nomeBloco => {
            const idsDoBloco = this.configuracaoBlocos[nomeBloco];

            const controlesDoBloco = formArray.controls.filter(control => 
            idsDoBloco.includes(Number(control.get('idPergunta').value))
            );

            const preenchidos = controlesDoBloco.filter(control => {
            const res = control.get('resposta').value;
            return res !== null && res !== undefined && res.toString().trim() !== '';
            }).length;

            return preenchidos === controlesDoBloco.length && controlesDoBloco.length > 0;
        });

        return existePeloMenosUmCompleto;
    }

    private itemRespostaTecnicia(): QuestionarioRespostaEnergiaDTO {
        let perguntaTecnica = this.getFormPerguntaTecnica();
        let itemResposta = new QuestionarioRespostaEnergiaDTO();
        let formGroupResposta: UntypedFormGroup = perguntaTecnica as UntypedFormGroup;
        itemResposta.idPergunta = formGroupResposta.controls.idPergunta.value;
        itemResposta.conteudo = formGroupResposta.controls.resposta.value;
        return itemResposta;
    }

}

function minSelectedCheckboxes(min = 1): any  {
    const validator: ValidatorFn = (formArray: UntypedFormArray) => {
      const totalSelected = formArray.controls
        // get a list of checkbox values (boolean)
        .map(control => control.value)
        // total up the number of checked checkboxes
        .reduce((prev, next) => next ? prev + next : prev, 0);
  
      // if the total is not greater than the minimum, return the error message
      return totalSelected >= min ? null : { required: true };
    };
}
